
import { useState } from 'react'
import { AvatarRoot as Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export function ProfileSection() {
  const [username, setUsername] = useState('genie423523')
  const [displayName, setDisplayName] = useState('Genie Anonimus')

  const handleUpdateProfile = () => {
    // TODO: Implement profile update
  }

  const handleUploadPhoto = () => {
    // TODO: Implement photo upload
  }

  return (
    <div className="p-6 flex flex-col gap-6">
      {/* Profile Information */}
      <div>
        <h3 className="text-base font-semibold">Profile Information</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Update your profile details and avatar.
        </p>
      </div>
      <div className="space-y-6">
          {/* Avatar Upload */}
          <div className="flex gap-4 items-center">
            <Avatar className="h-20 w-20">
              <AvatarImage src="/placeholder-avatar.jpg" alt="Profile" />
              <AvatarFallback className="bg-muted text-xl">GA</AvatarFallback>
            </Avatar>
            <div className="flex flex-col gap-2 flex-1">
              <Button
                variant="outline"
                size="lg"
                className="w-fit"
                onClick={handleUploadPhoto}
              >
                Upload new photo
              </Button>
              <p className="text-xs text-muted-foreground">
                At least 800x800px recommended. JPG or PNG is allowed
              </p>
            </div>
          </div>

          {/* Username */}
          <div className="space-y-2">
            <Label htmlFor="username">Username</Label>
            <Input
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <p className="text-xs text-muted-foreground">
              Unique tag for your account. You can only change this once every 30 days.
            </p>
          </div>

          {/* Display Name */}
          <div className="space-y-2">
            <Label htmlFor="displayName">Display Name</Label>
            <Input
              id="displayName"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
            />
            <p className="text-xs text-muted-foreground">
              This is your public display name. It can be your real name or a pseudonym.
            </p>
          </div>
      </div>

      {/* Save Button */}
      <div className="flex justify-end">
        <Button size="lg" onClick={handleUpdateProfile}>
          Update profile
        </Button>
      </div>
    </div>
  )
}
